import { render, staticRenderFns } from "./settlement-search.vue?vue&type=template&id=6f36f4fe&scoped=true"
import script from "./settlement-search.vue?vue&type=script&lang=js"
export * from "./settlement-search.vue?vue&type=script&lang=js"
import style0 from "./settlement-search.vue?vue&type=style&index=0&id=6f36f4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36f4fe",
  null
  
)

export default component.exports